import styled from 'styled-components';
import { t } from '../Table.styles';

const ItemUseState = ({ appraisalevaluation }: any) => {
  const appraisalevaluationArr = JSON.parse(appraisalevaluation);
  const flattenedArray = appraisalevaluationArr.flat();

  return (
    <Container>
      <Block>
        <Title>
          <img src="/assets/images/icon/servey.svg" alt="" />
          <span>이용현황</span>
        </Title>
        <t.Table>
          <tbody>
            <t.Row>
              <t.TitleCell width="110px">
                위치 및 <br /> 부근근황
              </t.TitleCell>
              <t.ContentCell width="100%">{flattenedArray[0]}</t.ContentCell>
            </t.Row>
            <t.Row>
              <t.TitleCell width="110px">이용현황</t.TitleCell>
              <t.ContentCell width="100%">{flattenedArray[1]}</t.ContentCell>
            </t.Row>
            <t.Row>
              <t.TitleCell width="110px">기타사항</t.TitleCell>
              <t.ContentCell width="100%">{flattenedArray[2]}</t.ContentCell>
            </t.Row>
          </tbody>
        </t.Table>
      </Block>
    </Container>
  );
};
export default ItemUseState;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  font-family: Spoqa Han Sans Neo;
  background-color: #fff;
`;

const Block = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Title = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  font-size: 18px;
  font-weight: 700;
  color: #222;
`;
